import React, { useState, useEffect, Suspense } from 'react';
import PropTypes from 'prop-types';
const ButtonEditUser = React.lazy(
  () => import('./Buttons/ButtonsEditUser.component')
);
const ResultModal = React.lazy(
  () => import('../../../../Components/Modal/ResultModal.component')
);
import ManagerEmployeeInput from '../../../../Components/UserForm/ManagerEmployeeInputs.component';
import ResentLoginEmail from './ResendLoginEmail/ResendLogin.component';

const UserEditInnerComponent = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [type, setType] = useState('');
  const [userState, setUserState] = useState(null);
  const [successState, setSuccessState] = useState('');
  useEffect(() => {
    if (user) {
      setUserState(user);
    }
  }, [user]);
  return (
    <div>
      <form>
        {/* Inputs for editing user*/}
        <Suspense fallback={<p>Loading user inputs...</p>}>
          <ManagerEmployeeInput
            user={userState}
            setUser={setUserState}
            showPassword={false}
            type={type}
            setType={setType}
            showType={true}
          />
        </Suspense>
        {/* Pop Up Modal */}
        <Suspense fallback={<p>Loading result modal...</p>}>
          <ResultModal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            result={successState}
            linkTo="/admin"
          />
        </Suspense>
        {/* Submit buttons */}
        <Suspense fallback={<p>Loading submit buttons...</p>}>
          <ButtonEditUser
            user={userState}
            type={type}
            setIsOpen={setIsOpen}
            successState={successState}
            setSuccessState={setSuccessState}
          />
        </Suspense>
      </form>
      <ResentLoginEmail user={user} />
    </div>
  );
};
UserEditInnerComponent.propTypes = {
  user: PropTypes.object,
};

export default UserEditInnerComponent;
